<template>
	<StampDetail v-if="detail" :id="id" :detail="detail" />
</template>
<script>
	import Util from '@/lib/Util.js';
	import StampDetail from '@/components/stamp/Detail.vue';

	export default {
		name: 'EventStampModify',
		components: {
			StampDetail,
		},
		data() {
			return {
				id: Number(this.$route.params.idStamp),
				detail: null,
			};
		},
		methods: {
			async getDetail() {
				try {
					const { data } = await this.$axiosAdmin2.get(
						`/v3/api/stamp/${this.id}`
					);
					this.detail = {
						...data.stamp,
						stamp_condition_list: data.stamp_condition_list,
						stamp_product_list: data.stamp_product_list.map(
							item => ({
								idProduct: item.product_id,
								filePath: item.image_url,
								brandTitle: item.brand.brand_title,
								productTitle: item.product_title,
								isDisplay: item.is_display,
								isDiscontinue: item.is_discontinue,
							})
						),
						start_on: Util.dateFormat(
							data.stamp.start_on,
							'YYYY-MM-DD'
						),
						finish_on: Util.dateFormat(
							data.stamp.finish_on,
							'YYYY-MM-DD'
						),
						reward_on: Util.dateFormat(
							data.stamp.reward_on,
							'YYYY-MM-DD'
						),
					};
				} catch (e) {
					console.error(e);
					alert(
						'출석체크 이벤트 데이터를 불러오는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
		},
		created() {
			this.getDetail();
		},
	};
</script>
<style lang="scss" scoped></style>
